export default __webpack_public_path__ + "static/Tek_Railing-19f7a713d71a49bc293ac495d86b412c.png";